"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusScope = void 0;
var _react = require("react");
var focusScope = exports.focusScope = /*#__PURE__*/(0, _react.createContext)(undefined);